var alignment_default = {
  "alignLeft": "_7CslP",
  "textWrapNowrap": "mdngM",
  "alignRight": "koLvT",
  "alignCenter": "Fwbrh",
  "sizeFullWidth": "jVzjr",
  "renderedInTable": "IhH5l",
  "sizeOriginal": "or94p",
  "sizeContent": "RaTAF",
  "sizeSmall": "UmqF5",
  "sizeSmallCenter": "_5lz7-",
  "flex": "FMggA",
  "LEFT": "VkKa3",
  "CENTER": "t1zYL",
  "RIGHT": "RK9py",
  "AUTO": "rcl0D",
  "JUSTIFY": "cq-ch"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
